// components
// import SvgIconStyle from '../../../../components/SvgIconStyle';
import Iconify from '../../../../components/Iconify';
// hooks
import useFeatureFlags from '../../../../hooks/useFeatureFlags';
import { FEATURES } from '../../../../constants/features';

// ----------------------------------------------------------------------

// const getIcon = (name: string) => (
//   <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />
// );

// const ICONS = {
//   user: getIcon('ic_user'),
//   ecommerce: getIcon('ic_ecommerce'),
//   analytics: getIcon('ic_analytics'),
//   dashboard: getIcon('ic_dashboard'),
// };

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: '',
    items: [
      {
        title: 'Dashboard',
        path: '/admin/dashboard',
        icon: <Iconify icon={'bx:bxs-dashboard'} width={32} height={32} />,
      },
      {
        title: 'Org Chart',
        path: '/admin/org-chart',
        icon: <Iconify icon={'icomoon-free:tree'} width={32} height={32} />,
      },
      {
        title: 'Employees',
        path: '/admin/employees',
        icon: <Iconify icon={'prime:users'} width={32} height={32} />,
      },
      {
        title: 'Performance',
        path: '/admin/performance',
        icon: <Iconify icon={'charm:rocket'} width={32} height={32} />,
        children: [
          {
            title: 'Goals',
            path: '/admin/performance/goals',
            icon: <Iconify icon={'fluent:target-arrow-20-filled'} width={32} height={32} />,
          },
          { title: 'Reviews', path: '/admin/performance/reviews' },
          { title: 'Surveys', path: '/admin/performance/surveys' },
        ],
      },
      {
        title: 'Learning',
        path: '/admin/learning',
        icon: <Iconify icon={'si-glyph:easal'} width={32} height={32} />,
        children: [
          {
            title: 'Training Courses',
            path: '/admin/learning',
            icon: <Iconify icon={'si-glyph:easal'} width={32} height={32} />,
          },
          {
            title: 'Training Tracker',
            path: '/admin/tracker',
            icon: <Iconify icon={'si-glyph:easal'} width={32} height={32} />,
          },
        ],
      },
      {
        title: 'Doc Library',
        path: '/admin/library',
        icon: <Iconify icon={'iconoir:multiple-pages'} width={32} height={32} />,
        children: [
          // TODO remove these pages
          {
            title: 'Library',
            path: '/admin/library',
            icon: <Iconify icon={'si-glyph:easal'} width={32} height={32} />,
          },
          {
            title: 'Pending Signature',
            path: '/admin/docs-pending',
            icon: <Iconify icon={'si-glyph:easal'} width={32} height={32} />,
          },
        ],
      },
      {
        title: 'Time Off',
        path: '/admin/time-off',
        icon: <Iconify icon={'ant-design:user-outlined'} width={32} height={32} />,
      },
    ],
  },

  // MANAGEMENT - separate section in the side nav
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'management',
  //   items: [
  //     {
  //       title: 'user',
  //       path: '/dashboard/user',
  //       icon: ICONS.user,
  //       children: [
  //         { title: 'Four', path: '/dashboard/user/four' },
  //         { title: 'Five', path: '/dashboard/user/five' },
  //         { title: 'Six', path: '/dashboard/user/six' },
  //       ],
  //     },
  //   ],
  // },
];

export default function NavConfig() {
  const { isFeatureEnabled } = useFeatureFlags();

  // Deep-copy items so the module-level navConfig is never mutated
  let filteredNavConfig = navConfig.map((section) => ({ ...section, items: [...section.items] }));
  if (!isFeatureEnabled(FEATURES.TIME_OFF)) {
    filteredNavConfig[0].items = filteredNavConfig[0].items.filter(
      (item: any) => item.title !== 'Time Off'
    );
  }
  if (!isFeatureEnabled(FEATURES.LEARNING)) {
    filteredNavConfig[0].items = filteredNavConfig[0].items.filter(
      (item: any) => item.title !== 'Learning'
    );
  }
  if (!isFeatureEnabled(FEATURES.ORG_CHART)) {
    filteredNavConfig[0].items = filteredNavConfig[0].items.filter(
      (item: any) => item.title !== 'Org Chart'
    );
  }

  return filteredNavConfig;
}

// export default navConfig;
